import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { MarkupEditorData } from "../../state/Markups/MarkupEditorData";
import { ValidationUtils } from '../../../utils/ValidationUtils';

const updateMarkupEditorData: Reducer<MarkupEditorData> = (state: MarkupEditorData = new MarkupEditorData(), action: Action<ActionType, MarkupEditorData>) => {
  switch (action.type) {
    case ActionType.MARKUP_EDITOR_DATA_RESET:
      return new MarkupEditorData();
    case ActionType.MARKUP_EDITOR_DATA_FETCHED:
      return { ...state, editorData: action.data };
    case ActionType.MARKUP_EDITOR_DATA_COPIED:
      return { ...state, editorData: { ...action.data, id: null } };
    case ActionType.MARKUP_EDITOR_DATA_UPDATED:
      return { ...state, editorData: { ...state.editorData, ...action.data } };
    case ActionType.MARKUP_EDITOR_DATA_VALIDATED:
      const formatedValidationFields = ValidationUtils.formatMarkupValidation(action.data);
      return { ...state, validation: formatedValidationFields, readyToSave: formatedValidationFields === null };
    case ActionType.MARKUP_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.MARKUP_EDITOR_DATA_SET_BRAND_AND_MARKET:
      return { ...state, editorData: {...state.editorData, systemContext: {...state.editorData?.systemContext, brandAndMarket: action.data}} };
    default:
      return state;
  }
};

export default updateMarkupEditorData;
